<template>
    <div id="page">
        <div class="page-content">
            <div class="page-title page-title-small">
                <h2><button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>ویرایش پست سازمانی </h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="150">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
                <div class="card-bg bg-20"></div>
            </div>
            <div class="card card-style">
                <div class="content mb-0">

                    <div class="input-style input-style-2 has-icon input-required">
                        <i class="input-icon fa fa-check color-magenta2-light"></i>
                        <span class="color-highlight" :class="{'input-style-1-active' : orgJobModel.title!==null}">عنوان</span>
                        <input class="form-control" type="text" v-model="orgJobModel.title" @input="v$.orgJobModel.title.$touch()" :class="{invalid:v$.orgJobModel.title.$error}">
                        <p class="text-danger" v-if="v$.orgJobModel.title.required.$invalid && v$.orgJobModel.title.$dirty">لطفا عنوان را وارد کنید.</p>
                    </div>

                   
                    <button :disabled="Loading" class="btn btn-xxs mt-2 mb-4 btn-full bg-green1-dark rounded-sm font-900 w-100" @click.prevent="CreateOrgJob">
                        <i class="fa fa-check font-10 ml-2"></i>
                        ثبت
                    </button>
                </div>
            </div>
        </div>
        <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
            <div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
                <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>درحال ارسال اطلاعات ...</div>
            </div>
        </transition>
    </div>
</template>
<script>
import useVuelidate from '@vuelidate/core'
    import {
        required
    } from "@vuelidate/validators";
    import 'vue-select/dist/vue-select.css';

    export default {
        setup: () => ({ v$: useVuelidate() }),
        data() {
            return {
                orgJobModel: {
                    code: "",
                    title: null,
                    orgJobId: 0,
                    userId: 0,
                    parentId: 0,
                    levelId:0
                },
            };
        },
        computed: {
            Loading() {
                return this.$store.getters.GetLoading;
            },
            
        },
        created() {
            this.GetOrgJobItem();
           
        },
        methods: {
           
            GetOrgJobItem() {
                this.$http.get("orgUnit/GetOrgJobItem?id=" + this.$route.params.orgJobId)
                    .then(data => {
                        this.orgJobModel = data.data;
                    });
            },
            CreateOrgJob() {
                this.v$.$touch();
                if (!this.v$.$invalid) { 
                    this.$store.dispatch("CreateOrgJob", this.orgJobModel);
                }
            },
           
        },
        validations: {
            orgJobModel: {
                title: {
                    required
                },
               
            }


        },
       
    };
</script>
